// extracted by mini-css-extract-plugin
export default {"CalendarWidget":"CalendarWidget_CalendarWidget__ZwIEV","CalendarWidgetContent":"CalendarWidget_CalendarWidgetContent__ol2GM"};